<template>
  <v-card>
    <v-card-title class="headline black--text" :style="backgroundStarStyle">
      <span>Guided tutorials</span>
      <v-spacer></v-spacer>
      <v-btn icon light small class="m-0" @click="closeGuidedTutorial()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card class="mx-2">
      <v-container
        fluid
        grid-list-lg
        class="px-3"
        :style="'max-height: ' + cardHeight + 'px; overflow-y: scroll'"
      >
        <v-col
          cols="12"
          v-for="(tutorial, index) in tutorialList"
          :key="index"
          @click="tutorialClicked(index)"
        >
          <v-hover>
            <v-card
              :color="cardBackground()"
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 10 : 2}`"
            >
              <v-col cols="11">
                <h3>{{ tutorial }}</h3>
              </v-col>
              <v-divider light></v-divider>
            </v-card>
          </v-hover>
        </v-col>
      </v-container>
    </v-card>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'guidedTutorialDashboard',

  data() {
    return {
      tutorialList: [
        'Discover spacestudio™',
        'Create a parametric orbital transfer mission (Part 1)',
        'Create a parametric orbital transfer mission (Part 2)',
        'Perform an analytical performance analysis on a constellation'
      ],
      cardHeight: 600
    }
  },

  computed: {
    backgroundStarStyle() {
      return (
        'background: #3BE287'
      )
    }
  },

  methods: {
    ...mapActions([
      'startATour',
      'start_gt_OrbitTransferParam1',
      'start_gt_OrbitTransferParam2',
      'start_gt_PerformanceAnalysis'
    ]),
    cardBackground() {
      if (this.$vuetify.theme.dark === false) {
        return 'grey lighten-4'
      } else {
        return ''
      }
    },

    closeGuidedTutorial() {
      this.$emit('guidedTutorialClosed')
    },

    tutorialClicked(tutorialIndex) {
      this.$emit('guidedTutorialClosed')
      switch (tutorialIndex) {
        case 0:
          this.startATour(true)
          this.$router.push('/missions')
          this.$tours['myTour'].start()
          break
        case 1:
          this.start_gt_OrbitTransferParam1({ param: 'isActive', val: true })
          this.$router.push('/createmission')
          break
        case 2:
          this.start_gt_OrbitTransferParam2({ param: 'isActive', val: true })
          this.$router.push('/missions')
          break
        case 3:
          this.start_gt_PerformanceAnalysis({ param: 'isActive', val: true })
          this.$router.push('/createmission')
      }
    }
  }
}
</script>
